import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { assets } from '../../assets';
import Presentation from '../../logic/redux/presentation';
import Button from '../buttons/button';
import { FormattedMessage, useIntl } from 'react-intl';
import TermsOfUseModalContent from './terms-of-use';

const Wrapper = styled.div`
  width: 100%;
`;

const WrapperHorizontal = styled.div`
  display: flex;
  flex-direction: row;
`;

const InfoText = styled.div`
  font-size: 10px;
  line-height: 12px;
  letter-spacing: -0.01em;
  color: #767676;
`;

const KonstruktorIcon = styled.img`
  height: 16px;
`;

const LegalLink = styled.span`
  font-size: 8px;
  line-height: 12px;
  letter-spacing: -0.01em;
  color: #767676;
  margin-right: 20px;
  text-decoration-line: underline;
  cursor: pointer;
  flex-wrap: nowrap;
  &:last-child {
    margin-right: 0px;
  }
`;

const ImpressumModalContent = (): JSX.Element => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const handleOkClick = (): void => {
    dispatch(Presentation.actions.setShowModal(undefined));
  };

  return (
    <div className="flex flex-col w-1/1">
      <h2 className="mb-4">
        <FormattedMessage id={'imprintModal.title'} />
      </h2>
      <section className="mb-5">
        <h3 className="mb-4">
          <u>
            <FormattedMessage id={'imprintModal.provider'} />
          </u>
        </h3>
        <p className="text-12 mb-2">
          <FormattedMessage id={'imprintModal.providerNameLabel'} /> CODEX Értéktár Zrt.
        </p>
        <p className="text-12 mb-2">
          <FormattedMessage id={'imprintModal.providerAddressLabel'} /> 2092 Budakeszi, Szüret utca
          5.
        </p>
        <p className="text-12 mb-2">
          <FormattedMessage id={'imprintModal.providerPhoneLabel'} /> +36 23 885 430
        </p>
        <p className="text-12 mb-2">
          <FormattedMessage id={'imprintModal.providerRegistrationNumberLabel'} /> 13 10 041615{' '}
        </p>
        <p className="text-12">
          <FormattedMessage id={'imprintModal.providerTaxNumberLabel'} /> 11033223-2-13
        </p>
      </section>
      <section className="mb-5">
        <h3 className="mb-4">
          <u>
            <FormattedMessage id={'imprintModal.legalNoticeText'} />
          </u>
        </h3>
        <p className="text-12 mb-2">
          <FormattedMessage id={'imprintModal.copyRightLabel'} />
        </p>
        <p
          className="text-12 mb-2"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'imprintModal.text1' }),
          }}
        />
        <p
          className="text-12"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'imprintModal.text2' }),
          }}
        />
      </section>

      <Button className="self-end" onClick={handleOkClick}>
        <FormattedMessage id={'imprintModal.okButton'} />
      </Button>
    </div>
  );
};

const LegalInformation = (): JSX.Element => {
  const dispatch = useDispatch();

  const handleImpressumClick = (): void => {
    dispatch(Presentation.actions.setShowModal(<ImpressumModalContent />));
  };

  return (
    <Wrapper>
      <InfoText className="mb-4">
        © {new Date().getFullYear()} CODEX Értéktár Zrt. -{' '}
        <FormattedMessage id={'footer.copyRight'} />
      </InfoText>
      <WrapperHorizontal className="mb-6 items-center">
        <InfoText className="mr-2">
          <FormattedMessage id={'footer.createdBy'} />
        </InfoText>
        <KonstruktorIcon src={assets.icons.konstruktor} alt="Konstruktor Online Kft." />
      </WrapperHorizontal>

      <WrapperHorizontal className="mb-6">
        <LegalLink onClick={handleImpressumClick}>
          <FormattedMessage id={'footer.imprint'} />
        </LegalLink>
      </WrapperHorizontal>
    </Wrapper>
  );
};

export default LegalInformation;
